module.exports = {
      id: "arrow-white-up-usage",
      viewBox: "0 0 18 13",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#arrow-white-up",
      toString: function () {
        return this.url;
      }
    }